import dayjs from 'dayjs';

import { useCurrentOrganizationBilling } from '@/hooks/useSwr';

import {
  getDisplayDateFromEndOfBillingPeriod,
  hasValidApprovals,
} from '../../utils/helpers';
import { isCancelledPlan } from '../../utils/isCancelledPlan';
import { PaymentPlanCardTiers } from '../types';

const thirtyDaysFromNow = dayjs().add(30, 'day');

export const useShowPlanStatusBadge = ({
  cardPlanType,
}: {
  cardPlanType: PaymentPlanCardTiers;
}) => {
  const { data: currentOrganization } = useCurrentOrganizationBilling();
  const currentPlan = currentOrganization?.current_plan;
  const upcomingPlan = currentOrganization?.upcoming_plan;
  const approvals = hasValidApprovals(currentOrganization);
  const isCurrentPlan =
    cardPlanType === currentPlan?.tier ||
    (cardPlanType === 'developer' && currentPlan?.tier === 'free');
  const upcomingPlanStartedOn = upcomingPlan?.started_on
    ? new Date(upcomingPlan.started_on)
    : null;
  const isUpcomingPlan =
    dayjs(upcomingPlanStartedOn).isBefore(thirtyDaysFromNow) &&
    (cardPlanType === upcomingPlan?.tier ||
      (cardPlanType === 'developer' && upcomingPlan?.tier === 'free'));

  const isApprovedPlan = approvals[cardPlanType];

  const hasCancelled =
    isCancelledPlan(currentPlan, upcomingPlan) &&
    cardPlanType === currentPlan?.tier;
  const endOfBillingPeriod = currentOrganization?.end_of_billing_period;
  const endOfBillingPeriodFormatted = endOfBillingPeriod
    ? getDisplayDateFromEndOfBillingPeriod(endOfBillingPeriod)
    : null;

  const showStatusBadge =
    isCurrentPlan || isUpcomingPlan || isApprovedPlan || hasCancelled;

  return {
    isCurrentPlan,
    isUpcomingPlan,
    isApprovedPlan,
    hasCancelled,
    upcomingPlanStartedOn,
    endOfBillingPeriodFormatted,
    showStatusBadge,
  };
};
